import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { auth } from "../firebase";

export default function AdminAboutEditor() {
  const [about, setAbout] = useState({ image: "", header: "", text: "" });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const fetchAbout = async () => {
      try {
        const token = await auth.currentUser.getIdToken();
        const res = await axios.get("/api/public/about", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setAbout(res.data.content);
      } catch (error) {
        console.error("Error fetching about:", error);
        toast.error("Error loading about section");
      } finally {
        setLoading(false);
      }
    };
    
    fetchAbout();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAbout((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const token = await auth.currentUser.getIdToken();
      await axios.put("/api/public/about", {
        content: about,
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      toast.success("Saved!");
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <p>Loading...</p>;

  return (
      <div>
        <h4>About Section</h4>
        <div className="mb-2">
          <label className="form-label">Header</label>
          <input
            className="form-control"
            name="header"
            value={about.header}
            onChange={handleChange}
          />
        </div>
        <div className="mb-2">
          <label className="form-label">Text</label>
          <textarea
            className="form-control"
            name="text"
            rows={2}
            value={about.text}
            onChange={handleChange}
          />
        </div>
        <div className="mb-2">
          <label className="form-label">Box Big Text</label>
          <input
            className="form-control"
            name="box_big_text"
            value={about.box_big_text}
            onChange={handleChange}
          />
        </div>
        <div className="mb-2">
          <label className="form-label">Enable Count-Up Animation</label>
          <select
            className="form-select"
            name="enable_animation"
            value={about.enable_animation !== false ? "true" : "false"}
            onChange={(e) => setAbout((prev) => ({ ...prev, enable_animation: e.target.value === "true" }))}
          >
            <option value="true">Yes - Animate the number</option>
            <option value="false">No - Show static number</option>
          </select>
          <small className="text-muted">
            When enabled, any number in "Box Big Text" will animate from 0 when the section comes into view.
          </small>
        </div>
        <div className="mb-2">
          <label className="form-label">Box Small Text</label>
          <input
            className="form-control"
            name="box_small_text"
            value={about.box_small_text}
            onChange={handleChange}
          />
        </div>
        <button className="btn btn-admin mt-1" onClick={handleSave} disabled={saving}>
          {saving ? "Saving..." : "Save"}
        </button>
      </div>
  );
}
